"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NewAnimatePresence = require("../../animation/NewAnimatePresence");
var _useScrollBlocker = require("../../hooks/useScrollBlocker");
var _layout = require("../../layout");
var _Overlay = require("../Overlay/Overlay");
var _Portal = require("../Portal");
var _PortalProvider = require("../PortalProvider");
var _modalStyles = require("./modalStyles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ModalWrapper = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const children = props.children,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? false : _props$visible,
    _props$disablePortal = props.disablePortal,
    disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
    accessibilityLabelledBy = props.accessibilityLabelledBy,
    accessibilityLabel = props.accessibilityLabel,
    customZIndex = props.zIndex,
    className = props.className,
    id = props.id,
    _props$disableOverlay = props.disableOverlayPress,
    disableOverlayPress = _props$disableOverlay === void 0 ? false : _props$disableOverlay,
    _props$dangerouslyDis = props.dangerouslyDisableResponsiveness,
    dangerouslyDisableResponsiveness = _props$dangerouslyDis === void 0 ? false : _props$dangerouslyDis,
    onOverlayPress = props.onOverlayPress,
    onDidClose = props.onDidClose,
    _props$hideOverlay = props.hideOverlay,
    hideOverlay = _props$hideOverlay === void 0 ? false : _props$hideOverlay,
    testID = props.testID,
    _props$role = props.role,
    role = _props$role === void 0 ? 'dialog' : _props$role;
  const blockScroll = (0, _useScrollBlocker.useScrollBlocker)();

  // prevent body scroll when modal is open
  (0, _react.useEffect)(() => {
    blockScroll(visible);
    return () => {
      blockScroll(false);
    };
  }, [visible, blockScroll]);
  return /*#__PURE__*/_react.default.createElement(_NewAnimatePresence.NewAnimatePresence, {
    onExitComplete: onDidClose
  }, visible && /*#__PURE__*/_react.default.createElement(_Portal.Portal, {
    containerId: _PortalProvider.modalContainerId,
    disablePortal: disablePortal
  }, /*#__PURE__*/_react.default.createElement(_layout.Box, {
    ref: ref,
    accessibilityLabel: accessibilityLabel,
    accessibilityLabelledBy: accessibilityLabelledBy,
    alignItems: "center",
    "aria-modal": "true",
    className: className,
    height: "100vh",
    id: id,
    justifyContent: "center",
    pin: "all",
    position: "fixed",
    role: role,
    testID: testID,
    width: "100vw",
    zIndex: customZIndex
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideOverlay && /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, {
    animated: true,
    className: !dangerouslyDisableResponsiveness ? _modalStyles.modalOverlayResponsiveClassName : undefined,
    onPress: !disableOverlayPress ? onOverlayPress : undefined,
    testID: "modal-overlay"
  }), children))));
}));
exports.ModalWrapper = ModalWrapper;